import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
dayjs.extend(timezone);

export const TOTAL_LIFETIME_DONATIONS_DATE = 'TOTAL_LIFETIME_DONATIONS_DATE';

const REQUEST_TIMEOUT_MINUTES = 30;

export const setDateLifeTimeDonations = (doneeId: number): void =>
    localStorage.setItem(
        TOTAL_LIFETIME_DONATIONS_DATE,
        JSON.stringify({ doneeId, date: dayjs() }),
    );

export const getDateLifeTimeDonations = (): string | null =>
    localStorage.getItem(TOTAL_LIFETIME_DONATIONS_DATE);

export const shouldRequestLifeTimeDonation = (doneeId: number): boolean => {
    const lsData = JSON.parse(getDateLifeTimeDonations());
    if (!lsData) return true;
    const newDate = dayjs();
    const prevDate = dayjs(lsData.date);

    const lsDoneeId = lsData.doneeId;
    const timeDifferenceInMinutes = dayjs(newDate).diff(
        dayjs(prevDate),
        'minute',
    );

    return (
        timeDifferenceInMinutes > REQUEST_TIMEOUT_MINUTES ||
        lsDoneeId !== doneeId
    );
};
